import React, { useEffect, useState } from 'react'
import moment from 'moment'
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBIcon,
  MDBRow,
  MDBCol,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../../../../components/content/MDB4Datatable/MDB4Datatable.component'
import './ResendEmailModal.scss'
import UserEmailHistoryService from '../../../../shared/services/UserEmailHistory.service'
import { toast } from 'react-toastify'

const columns = [
  {
    label: 'Name',
    field: 'email_name',
    sort: 'asc',
  },
  {
    label: 'Subject',
    field: 'email_subject',
    sort: 'asc',
  },
  {
    label: 'Email To',
    field: 'email_to',
    sort: 'asc',
  },
  {
    label: 'Emailed at',
    field: 'email_sent',
    sort: 'asc',
  },
]

const replacePlaceholders = (template, data) => {
  return template.replace(/{(.*?)}/g, (match, key) => {
    return key in data ? data[key] : match
  })
}

const isHiddenKey = key => key && ['agent_password'].includes(key)

const isHtmlKey = key =>
  key &&
  [
    'carrier_agent_intro_details',
    'carrier_agent_eo_policy_table',
    'carrier_agent_attachment_table',
    'carrier_agent_state_license_table',
  ].includes(key)

const formatPayloadValue = value => {
  if (Array.isArray(value))
    return value.map((item, index) => (
      <span key={index} className='d-block'>
        {formatPayloadValue(item)}
      </span>
    ))
  if (value && typeof value === 'object')
    return Object.entries(value)
      .map(([k, v]) => `${k.replace(/_/g, ' ')}: ${v && typeof v === 'object' ? JSON.stringify(v) : v}`)
      .join(', ')
  return value
}

export const ResendEmailModal = ({ data, show, onCloseModal, emails }) => {
  const [emailHistories, setEmailHistories] = useState([])
  const [infoOpened, setInfoOpened] = useState(false)
  const [selectedEmail, setSelectedEmail] = useState(null)
  const [isResending, setIsResending] = useState(false)

  const resendEmail = async id => {
    setIsResending(true)
    try {
      await UserEmailHistoryService.resend(id)
      toast.success('The email has been resent!', {
        position: toast.POSITION.TOP_RIGHT,
      })
      setIsResending(false)
    } catch (error) {
      toast.error('Something went wrong! Failed to resend the email', {
        position: toast.POSITION.TOP_RIGHT,
      })
      setIsResending(false)
    }
  }

  useEffect(() => {
    if (data?.length > 0 && emails?.length > 0) {
      const email_histories = data.map(item => {
        const email_template = emails.find(email => email.id === item.get('template_id'))

        return {
          email_name: email_template?.email_name,
          email_subject: replacePlaceholders(email_template?.email_subject, item.get('payload')?.merge_fields),
          email_to: item.get('recipients')?.to,
          email_sent: (
            <span data-searchvalue={item.get('created_at') ? moment(item.get('created_at')).format('YYYY/MM/DD') : ''}>
              {item.get('created_at') ? moment(item.get('created_at')).format('MM/DD/YYYY') : 'N/A'}
            </span>
          ),
          clickEvent: () => {
            setInfoOpened(true)
            setSelectedEmail({
              id: item.get('id'),
              email_cc: item.get('recipients')?.cc || [],
              email_bcc: item.get('recipients')?.bcc || [],
              email_payload: item.get('payload')?.merge_fields,
            })
          },
        }
      })
      setEmailHistories(email_histories)
    }
  }, [data, emails])

  return (
    <MDBModal open={show} tabIndex='-1' onClose={() => onCloseModal(false)} id='ResendEmailModal'>
      <MDBModalDialog size='lg'>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Email History</MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={() => onCloseModal(false)}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            {data?.length > 0 ? (
              <div>
                <MDBRow>
                  <MDBCol size='12' lg={infoOpened ? '8' : '12'}>
                    <MDB4Datatable
                      data={{
                        columns,
                        rows: emailHistories,
                      }}
                      searching={false}
                      sortRows={['email_name', 'email_subject', 'email_to', 'email_sent']}
                      paging={true}
                      striped
                      responsive
                      bordered
                      entries={10}
                      entriesOptions={[10, 20, 50]}
                      hover
                    />
                  </MDBCol>
                  {infoOpened && (
                    <MDBCol size='12' lg='4'>
                      <div className='emailDetail'>
                        <div className='emailDetailHeader'>
                          <h5>Email Details</h5>
                          <MDBIcon
                            icon='times-circle'
                            onClick={e => {
                              setInfoOpened(false)
                              setSelectedEmail(null)
                            }}
                            className='close-icon'
                          ></MDBIcon>
                        </div>
                        <div>
                          <strong>Email CC:</strong>
                          {selectedEmail.email_cc.length > 0 ? (
                            selectedEmail.email_cc.map((item, index) => {
                              return <p key={index}>{item}</p>
                            })
                          ) : (
                            <p>N/A</p>
                          )}
                        </div>
                        <div>
                          <strong>Email BCC:</strong>
                          {selectedEmail.email_bcc.length > 0 ? (
                            selectedEmail.email_bcc.map((item, index) => {
                              return <p key={index}>{item}</p>
                            })
                          ) : (
                            <p>N/A</p>
                          )}
                        </div>
                        <div>
                          {Object.keys(selectedEmail.email_payload).map(key => (
                            <div key={key}>
                              <strong style={{ textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}:</strong>
                              <p>
                                {isHiddenKey(key) ? (
                                  '*****'
                                ) : isHtmlKey(key) ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: `${selectedEmail.email_payload[key]}`,
                                    }}
                                  />
                                ) : (
                                  formatPayloadValue(selectedEmail.email_payload[key])
                                )}
                              </p>
                            </div>
                          ))}
                        </div>
                        <div>
                          <MDBBtn
                            type='button'
                            color='success'
                            size='sm'
                            onClick={() => {
                              resendEmail(selectedEmail.id)
                            }}
                            disabled={isResending}
                          >
                            {isResending ? 'Resending...' : 'Resend'}
                          </MDBBtn>
                        </div>
                      </div>
                    </MDBCol>
                  )}
                </MDBRow>
              </div>
            ) : (
              'No emails sent to this agent'
            )}
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn
              type='button'
              color='danger'
              size='sm'
              onClick={() => {
                onCloseModal(false)
                setInfoOpened(false)
              }}
            >
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}
